export const COLUMN_WIDTH = {
  DATE: 190,
  ACTIONS: 150,
  TYPE: 200,
} as const
